import { Tag } from "antd";

function RelationInfoHeader({ article }) {
  if(!article) return null;

  return <div>
    <Tag>{article.type.toUpperCase()}</Tag>
    <h3>{article.title}</h3>
  </div>
}

export default RelationInfoHeader;